export default {
  'base.resetPassword.title': '重置密码',
  'base.resetPassword.subtitle': '请设置新的登录密码',
  'base.resetPassword.invalidToken': '重置链接无效',
  'base.resetPassword.passwordMin': '密码至少 6 个字符',
  'base.resetPassword.mismatch': '两次输入的密码不一致',
  'base.resetPassword.success': '密码已重置，请重新登录',
  'base.resetPassword.failed': '重置失败',
  'base.resetPassword.newLabel': '新密码',
  'base.resetPassword.newRequired': '请输入新密码',
  'base.resetPassword.minPlaceholder': '至少 6 个字符',
  'base.resetPassword.confirmLabel': '确认新密码',
  'base.resetPassword.confirmPlaceholder': '再次输入新密码',
  'base.resetPassword.confirmRequired': '请再次输入新密码',
}
